import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import { useDialog, useLegacyEffect } from "helper/customHook";
import { DIALOG } from "helper/enum/dialogEnum";
import { isOpenDialogSelector } from "redux-store/static/redux/selector";
import { useDispatch, useSelector } from "react-redux";
import pxToRem from "theme/base/pxToRem";
import {
  DialogTitleCustom,
  Title,
} from "modules/PersonnelInformation/Pages/Main/component/modal/style";
import { ReactComponent as IconClose } from "assets/svg/20-close.svg";
import {
  getFeedbackDetailDataSelector,
  getFeedbackDetailStatusSelector,
} from "modules/DeclareLeave/redux/selector";
import { resetListArriveLateDetail } from "modules/DeclareLeave/redux/getArriveLateDetail";
import { formatDateStringToDDMMYYYY } from "helper/utils";
import {
  ApproveStatus,
  ApproveStatusValue,
  IApproveStatus,
  statusColor,
  TitleContent,
} from "../../const";
import { setupDataRequest } from "modules/DeclareLeave/redux/handleRequest";
import EmptyState from "components/common/EmptyState";
import { ReduxStateType } from "redux-store/types";
import { TYPE_LEAVE } from "modules/DeclareLeave/redux/getReasonLeave";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { setupFeedback } from "modules/DeclareLeave/redux/sendFeedback";
import moment from "moment";
import { setDeleteRequestData } from "modules/DeclareLeave/redux/deleteRequest";
import { getFeedbackDetailStart } from "modules/DeclareLeave/redux/getFeedbackDetail";
import { SCREEN } from "helper/roleChecker/Screens";
import isString from "lodash/isString";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent";
import { toast } from "react-toastify";
import { ReactComponent as IconCopy } from "assets/svg/20-copy.svg";
import { TimeCheckWrapper } from "../../style";
import { Time, TimeInOutLable } from "../../CustomCalendarHeader/style";

const ResponseDetails = () => {
  const { id: idViewDetail } = useParams();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { tab } = useParams();
  const navigate = useNavigate();

  const requestLeaveDialog = useDialog(DIALOG.RESPONSE_DETAIL);
  const approveDialog = useDialog(DIALOG.APPROVE_REQUEST_POPUP);
  const sendFeedbackDialog = useDialog(DIALOG.SEND_FEEDBACK);
  const confirmDialog = useDialog(DIALOG.MODAL_CONFIRM);

  const open = useSelector(isOpenDialogSelector(DIALOG.RESPONSE_DETAIL));
  const data = useSelector(getFeedbackDetailDataSelector);
  const status = useSelector(getFeedbackDetailStatusSelector);

  const renderBoxContent = (
    title: string,
    content: string | number,
    hasDivdiver?: boolean,
    paddingBottom: number = 1.5,
    fontWeightContent?: 400 | 500 | 600
  ) => (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      sx={(theme) => ({
        paddingBottom: paddingBottom,
        borderBottom: hasDivdiver
          ? `1px solid ${theme.palette.stroke.strokeDefault2}`
          : "none",
        marginBottom: hasDivdiver ? 1.5 : 0,
      })}
    >
      <Typography
        sx={(theme) => ({
          fontSize: theme.typography.size.sm_14,
          color: theme.palette.text.textSecondary,
          fontWeight: theme.typography.fw_regular_400,
          width: "40%",
        })}
      >
        {title}
      </Typography>
      <Typography
        sx={(theme) => ({
          fontSize: theme.typography.size.sm_14,
          color:
            title === TitleContent.status
              ? statusColor(theme, content as IApproveStatus, "color")
              : theme.palette.text.textPrimary,
          fontWeight: fontWeightContent ?? theme.typography.fw_regular_400,
          flex: 1,
          textAlign: "right",
        })}
      >
        {title === TitleContent.status
          ? ApproveStatus[content]
          : (content ?? "---")}
      </Typography>
    </Box>
  );

  const onClickApprove = (isApprove: boolean) => {
    handleClose();
    dispatch(setupDataRequest({ isApprove, id: data?.id }));
    approveDialog.open();
  };

  const handleClose = () => {
    dispatch(resetListArriveLateDetail());
    requestLeaveDialog.close();
    const newURL = pathname.replace(`/${idViewDetail}`, "");
    navigate(newURL, { replace: true });
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    dispatch(
      setupFeedback({
        id: data.id,
        date: moment(data.createdDate).format("DD/MM/YYYY"),
        reason: data.description,
        type: data.type,
        explainAllow: data.explainAllow,
      })
    );
    sendFeedbackDialog.open();
    handleClose();
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    dispatch(setDeleteRequestData(data.id));
    handleClose();
    confirmDialog.open();
  };

  useLegacyEffect(() => {
    if (idViewDetail) {
      dispatch(
        getFeedbackDetailStart({
          screenCode: SCREEN.IP_016,
          id: idViewDetail,
        })
      );
      requestLeaveDialog.open();
    }
  }, [idViewDetail]);

  const handleCopyLink = () => {
    const linkToCopy = window.location.href.replace(
      declareLeaveURL.orderLeave,
      declareLeaveURL.orderManagement
    );
    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => {
        toast.success("Đã sao chép liên kết");
      })
      .catch(() => {
        toast.error("Sao chép liên kết thất bại");
      });
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitleCustom>
        <Title>Chi tiết đơn phản hồi</Title>
        <IconButton onClick={handleClose}>
          <IconClose />
        </IconButton>
      </DialogTitleCustom>
      {isString(data) && status !== ReduxStateType.INIT && (
        <DialogContent>
          <EmptyState message={data} />
        </DialogContent>
      )}
      {status === ReduxStateType.SUCCESS && (
        <>
          <DialogContent
            sx={(theme) => ({
              background: theme.palette.background.bgTertiary,
              p: 0,
            })}
          >
            <Box
              sx={(theme) => ({
                margin: 2,

                padding: pxToRem(20),
                paddingBottom: 1,
                background: "white",
                borderRadius: pxToRem(8),
              })}
            >
              {renderBoxContent(
                TitleContent.createDate,
                formatDateStringToDDMMYYYY(data?.createdDate)
              )}
              {tab === "order-management" && (
                <>
                  {renderBoxContent(
                    TitleContent.employeeName,
                    data?.employeeName,
                    false,
                    0
                  )}
                  {renderBoxContent(
                    "",
                    `${data?.positionName} - ${data?.departmentName}`
                  )}
                  <Divider />
                </>
              )}

              {/* Leave Details */}

              {/* Leave Summary */}

              {renderBoxContent(
                TitleContent.feedbackDate,
                data?.date ? formatDateStringToDDMMYYYY(data?.date) : "---"
              )}
              {renderBoxContent(
                TitleContent.workAmount,
                `${data?.type === TYPE_LEAVE.FULL_DAY ? "Cả ngày" : "Nửa ngày"}`
              )}
              {renderBoxContent(TitleContent.reason, data?.description, true)}

              {/* Approval Process */}
              {renderBoxContent(TitleContent.approval, data?.approverName)}
              {renderBoxContent(
                TitleContent.status,
                data?.confirmStatus,
                false,
                1.5,
                600
              )}
              {data?.refuseReason &&
                renderBoxContent(TitleContent.refuseReason, data?.refuseReason)}

              {renderBoxContent(
                TitleContent.approvalDate,
                data?.confirmDate
                  ? formatDateStringToDDMMYYYY(data?.confirmDate)
                  : "---"
              )}

              <TimeCheckWrapper dayType="timeChecking">
                <TimeInOutLable>Giờ vào ra</TimeInOutLable>
                <Time>
                  {data?.checkInTime ?? "---"} - {data?.checkOutTime ?? "---"}
                </Time>
              </TimeCheckWrapper>

              {idViewDetail && (
                <Button
                  variant="outlined"
                  color="primary"
                  sx={{ width: "100%", mt: 2 }}
                  onClick={handleCopyLink}
                >
                  <IconCopy />
                  <Typography
                    sx={(theme) => ({
                      color: theme.palette.text.textLink,
                      fontWeight: theme.typography.fw_semibold_600,
                      ml: 1,
                    })}
                  >
                    Sao chép liên kết
                  </Typography>
                </Button>
              )}
            </Box>
          </DialogContent>

          {/* Actions */}
          <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
            <Box display="flex" width={"100%"}>
              <Button
                variant="blur"
                fullWidth
                onClick={handleClose}
                sx={(theme) => ({
                  mr: 1,
                  background: theme.palette.background.bgSecondary,
                  color: theme.palette.text.textPrimary,
                })}
              >
                Đóng
              </Button>
              {tab === "order-management" ? (
                <>
                  <Button
                    color="success"
                    fullWidth
                    sx={{ mr: 1, gap: 1 }}
                    disabled={
                      data?.confirmStatus !== ApproveStatusValue.PENDING
                    }
                    onClick={() => onClickApprove(true)}
                  >
                    Phê duyệt
                  </Button>
                  <Button
                    color="error"
                    fullWidth
                    sx={{ gap: 1 }}
                    disabled={
                      data?.confirmStatus !== ApproveStatusValue.PENDING
                    }
                    onClick={() => onClickApprove(false)}
                  >
                    Từ chối
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="blur"
                    color="primary"
                    fullWidth
                    sx={{ mr: 1, gap: 1 }}
                    disabled={
                      data?.confirmStatus !== ApproveStatusValue.PENDING ||
                      !data.editable
                    }
                    onClick={handleEdit}
                  >
                    Chỉnh sửa
                  </Button>
                  <Button
                    variant="blur"
                    color="error"
                    fullWidth
                    sx={{ gap: 1 }}
                    disabled={
                      data?.confirmStatus !== ApproveStatusValue.PENDING ||
                      !data.editable
                    }
                    onClick={handleDelete}
                  >
                    Xóa
                  </Button>
                </>
              )}
            </Box>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ResponseDetails;
